$(document).ready(function() {
// Sayfa başına gösterilecek kayıt sayısı
   $('#DXrapnetrecordsPerPage').on('change', function() {
        mongolimit = parseInt($(this).val()); // Seçilen yeni kayıt sayısını al
        currentPage = 1; // Sayfa numarasını sıfırla
        fetchDiamonds(currentPage); // Yeni limit ile verileri yeniden yükle
    });

   $('#dx-rapgab-min-price-range, #dx-rapgab-min-price-input').on('change', function() {
      let minValue = parseFloat($(this).val());
      $('#dx-rapgab-min-price-range, #dx-rapgab-min-price-input').val(minValue);
    
      let maxValue = parseFloat($('#dx-rapgab-max-price-input').val());
      if (minValue >= maxValue) {
        maxValue = minValue;
        $('#dx-rapgab-max-price-range, #dx-rapgab-max-price-input').val(maxValue);
      }
    });
    
    $('#dx-rapgab-max-price-range, #dx-rapgab-max-price-input').on('change', function() {
      let maxValue = parseFloat($(this).val());
      $('#dx-rapgab-max-price-range, #dx-rapgab-max-price-input').val(maxValue);
    
      let minValue = parseFloat($('#dx-rapgab-min-price-input').val());
      if (minValue >= maxValue) {
        minValue = maxValue;
        $('#dx-rapgab-min-price-range, #dx-rapgab-min-price-input').val(minValue);
      }
      
    });
    
    $('.dx-rapgab-price-range, .dx-rapgab-price-input').on('change', function() {
      minPrice = parseFloat($('#dx-rapgab-min-price-input').val() / dxCurrency) || 0;
      maxPrice = parseFloat($('#dx-rapgab-max-price-input').val() / dxCurrency) || 5000000;
      updatePriceHighlight();
      fetchDiamonds(1);
    });
  
    function updatePriceHighlight() {
      const minPriceVal = $('#dx-rapgab-min-price-range').val();
      const maxPriceVal = $('#dx-rapgab-max-price-range').val();
      const maxPriceAttr = parseFloat($('#dx-rapgab-max-price-range').attr('max'));
      const minPriceAttr = parseFloat($('#dx-rapgab-min-price-range').attr('min'));
    
      const minPricePercent = ((minPriceVal - minPriceAttr) / (maxPriceAttr - minPriceAttr)) * 100;
      const maxPricePercent = ((maxPriceVal - minPriceAttr) / (maxPriceAttr - minPriceAttr)) * 100;
    
      $('.dx-rapgab-highlight-track-price').css({
        'left': `${minPricePercent}%`,
        'right': `${100 - maxPricePercent}%`
      });
    }
      
     // Minimum carat değeri için input event handler
    $('#dx-rapgab-min-carat-range, #dx-rapgab-min-carat-input').on('change', function() {
        let minValue = parseFloat($(this).val());
        // Diğer min-carat inputunu güncelle
        $('#dx-rapgab-min-carat-range, #dx-rapgab-min-carat-input').not(this).val(minValue);
      
        // Max değeri kontrol et ve gerekirse güncelle
        let maxValue = parseFloat($('#dx-rapgab-max-carat-input').val());
        if (minValue >= maxValue) {
            maxValue = minValue;
            $('#dx-rapgab-max-carat-range, #dx-rapgab-max-carat-input').val(maxValue);
        }
    });
    
    // Maximum carat değeri için input event handler
    $('#dx-rapgab-max-carat-range, #dx-rapgab-max-carat-input').on('change', function() {
        let maxValue = parseFloat($(this).val());
        // Diğer max-carat inputunu güncelle
        $('#dx-rapgab-max-carat-range, #dx-rapgab-max-carat-input').not(this).val(maxValue);
        // Min değeri kontrol et ve gerekirse güncelle
        let minValue = parseFloat($('#dx-rapgab-min-carat-input').val());
        if (minValue >= maxValue) {
            minValue = maxValue;
            $('#dx-rapgab-min-carat-range, #dx-rapgab-min-carat-input').val(minValue);
        }
        
    });

      
    $('.dx-rapgab-carat-range, .dx-rapgab-carat-input').on('change', function() {
      minSize = parseFloat($('#dx-rapgab-min-carat-input').val()) || 0.3;
      maxSize = parseFloat($('#dx-rapgab-max-carat-input').val()) || 20;
      updateCaratHighlight();
      fetchDiamonds(1);
    });

    // Range input'ları için olay dinleyicisi
    $('.dx-rapgab-carat-range').on('input', function() {
      // Minimum ve maksimum range input değerlerini al
      const minCaratVal = $('#dx-rapgab-min-carat-range').val();
      const maxCaratVal = $('#dx-rapgab-max-carat-range').val();
      
      // Bu değerleri number input'lara aktar
      $('#dx-rapgab-min-carat-input').val(minCaratVal);
      $('#dx-rapgab-max-carat-input').val(maxCaratVal);
      
      // Karat değerlerinin görsel vurgusunu güncelle
      updateCaratHighlight();
    });

    function updateCaratHighlight() {
      const minCaratVal = $('#dx-rapgab-min-carat-range').val();
      const maxCaratVal = $('#dx-rapgab-max-carat-range').val();
      const maxCaratAttr = parseFloat($('#dx-rapgab-max-carat-range').attr('max'));
      const minCaratAttr = parseFloat($('#dx-rapgab-min-carat-range').attr('min'));
    
      const minCaratPercent = ((minCaratVal - minCaratAttr) / (maxCaratAttr - minCaratAttr)) * 100;
      const maxCaratPercent = ((maxCaratVal - minCaratAttr) / (maxCaratAttr - minCaratAttr)) * 100;
    
      $('.dx-rapgab-highlight-track-carat').css({
        'left': `${minCaratPercent}%`,
        'right': `${100 - maxCaratPercent}%`
      });
    }

  
$('#dx-rapgab-color-range-min, #dx-rapgab-color-range-max').on('input', function() {
  var minValue = parseInt($('#dx-rapgab-color-range-min').val());
  var maxValue = parseInt($('#dx-rapgab-color-range-max').val());

  // Eğer minimum değer maksimum değere eşit veya ondan büyükse, 
  // maksimum değeri minimum değerden en az 2 birim yüksek yap
  if (minValue > 14) {
    minValue = 14;
    $('#dx-rapgab-color-range-min').val(minValue);
  }
  if (minValue >= maxValue - 2) {
    maxValue = minValue + 2;
    $('#dx-rapgab-color-range-max').val(maxValue);
  }

  updateColorRangeFromLabels(minValue, maxValue);
  minColor = convertColorValueToLetter(minValue + 2);
  maxColor = convertColorValueToLetter(maxValue);
  fetchDiamonds(1);
});


// Click event for labels
$('.dx-color-range-labels span').click(function() {
  var minValue = $(this).data('min');
  var maxValue = $(this).data('max');
  updateColorRangeFromLabels(minValue, maxValue);
  maxColor = convertColorValueToLetter(maxValue);
  minColor = maxColor;
  fetchDiamonds(1);
});
  
function convertColorValueToLetter(value) {
  if (value === 2 || value === 0) return 'D';
  else if (value === 4) return 'E';
  else if (value === 6) return 'F';
  else if (value === 8) return 'G';
  else if (value === 10) return 'H';
  else if (value === 12) return 'I';
  else if (value === 14) return 'J';
  else if (value === 16) return 'K';
  return null;
}

function updateColorRangeFromLabels(minValue, maxValue) {
  $('#dx-rapgab-color-range-min').val(minValue);
  $('#dx-rapgab-color-range-max').val(maxValue);
  updateColorHighlight();
}

function updateColorHighlight() {
  var minColorVal = parseInt($('#dx-rapgab-color-range-min').val());
  var maxColorVal = parseInt($('#dx-rapgab-color-range-max').val());
  var width = (maxColorVal - minColorVal) / 16 * 100; 
  var left = minColorVal / 16 * 100;
  
  $('.dx-rapgab-highlight-track-color').css({
    'left': left + '%',
    'width': width + '%'
  });
}


// Laboratuvarlar için etkinlik dinleyicileri
$('.dx-rapgab-certificate-button').on('click', function() {
    const labValue = $(this).data('value');
    const isActive = $(this).hasClass('active');
    $(this).toggleClass('active');
    chosenLabs = isActive ? chosenLabs.filter(lab => lab !== labValue) : [...chosenLabs, labValue];

    fetchDiamonds(1);
});

// Şekiller için etkinlik dinleyicileri
$('.dx-rapgab-shape-button').on('click', function() {
    const shapeValue = $(this).data('value');
    const isActive = $(this).hasClass('active');
    const isNotAllowed = $(this).hasClass('not-allowed');

    if (isNotAllowed) {
      event.preventDefault(); 
    } else {
      $(this).toggleClass('active');
      if (isActive) {
          chosenShapes = chosenShapes.filter(shape => shape !== shapeValue);
           $('#dx-rapgab-cut-range-min').val(0);
           $('#dx-rapgab-cut-range-max').val(3);
           $('.dx-rapgab-highlight-track-cut').css({
              'left': '0',
              'width': '100%'
          });
          if (shapeValue === "Cushion") {
              chosenShapes = chosenShapes.filter(shape => shape !== "Cushion%20Modified");
          }
      } else {
          chosenShapes.push(shapeValue);
          if (shapeValue === "Cushion" && !chosenShapes.includes("Cushion%20Modified")) {
              chosenShapes.push("Cushion%20Modified");
          }
      }
      if(chosenShapes.includes("Round") || chosenShapes.length === 0) {
          $('.dx-rapgab-slider-cut-filter').removeClass('dx-filter-disabled');
      } else {
        $('.dx-rapgab-slider-cut-filter').addClass('dx-filter-disabled');
        chosenCuts = [""];
      }
      fetchDiamonds(1);
    }
});


const clarityOrder = ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2'];
const clarityIndex = {
  'FL': 0,
  'IF': 2,
  'VVS1': 4,
  'VVS2': 6,
  'VS1': 8,
  'VS2': 10,
  'SI1': 12,
  'SI2': 14
};

// Clarity etiketlerine tıkladığında çalışacak fonksiyon
// Bu fonksiyon, hem slider hem de etiket tıklamalarında çağrılmalıdır.
function updateClaritySelection() {
  var minValue = parseInt($('#dx-rapgab-clarity-range-min').val());
  var maxValue = parseInt($('#dx-rapgab-clarity-range-max').val());

  // Eğer minimum değer maksimum değere eşit veya ondan büyükse, 
  // maksimum değeri minimum değerden en az 2 birim yüksek yap
  if (minValue > 14) {
    minValue = 14;
    $('#dx-rapgab-clarity-range-min').val(minValue);
  }
  if (minValue >= maxValue - 2) {
    maxValue = minValue + 2;
    $('#dx-rapgab-clarity-range-max').val(maxValue);
  }

  const minIndex = minValue / 2;
  const maxIndex = maxValue / 2;
  chosenClarity = [];

  for (let i = minIndex; i < maxIndex; i++) {
    chosenClarity.push(clarityOrder[i]);
  }

  // Clarity highlight güncellenir.
  const width = ((maxValue - minValue) / 16) * 100; 
  const left = (minValue / 16) * 100;
  $('.dx-rapgab-highlight-track-clarity').css({
    'left': left + '%',
    'width': width + '%'
  });

  // Verileri yeniden çeker.
  fetchDiamonds(1);
}

// Clarity etiketlerine tıkladığında çalışacak fonksiyon
$('.dx-clarity-range-labels span').on('click', function() {
  const clarityValue = $(this).data('value');
  const index = clarityIndex[clarityValue];

  // Sadece tıklanan clarity değerini alın
  chosenClarity = [clarityValue];

  // Slider değerlerini güncelle
  $('#dx-rapgab-clarity-range-min').val(index);
  $('#dx-rapgab-clarity-range-max').val(index + 2);

  // Clarity seçimini güncelle
  updateClaritySelection();
});

// Range inputlar için event listener
$('#dx-rapgab-clarity-range-min, #dx-rapgab-clarity-range-max').on('input', updateClaritySelection);

const cutOrder = ['Excellent', 'Very%20Good', 'Good'];
const cutIndex = {
  'Excellent': 0,
  'Very%20Good': 1,
  'Good': 2
};

// Cut etiketlerine tıkladığında çalışacak fonksiyon
// Bu fonksiyon, hem slider hem de etiket tıklamalarında çağrılmalıdır.
function updateCutSelection() {
  let minValue = parseInt($('#dx-rapgab-cut-range-min').val());
  let maxValue = parseInt($('#dx-rapgab-cut-range-max').val());

   // Eğer minimum değer maksimum değerden büyükse, maksimum değeri minimum değerle eşitle
  if (minValue > 2) {
    minValue = 2;
    $('#dx-rapgab-cut-range-min').val(minValue);
  }
  if (minValue >= maxValue) {
    maxValue = minValue + 1;
    $('#dx-rapgab-cut-range-max').val(maxValue);
  }
    
  chosenCuts = [""];
  for (let i = minValue; i < maxValue; i++) {
    chosenCuts.push(cutOrder[i]);
  }

  // Cut highlight güncellenir.
  const width = ((maxValue - minValue) / 3) * 100;
  const left = (minValue / 3) * 100;
  $('.dx-rapgab-highlight-track-cut').css({
    'left': left + '%',
    'width': width + '%'
  });

  // Verileri yeniden çeker.
  fetchDiamonds(1);
}

$('.dx-cut-range-labels span').on('click', function() {
  const cutValue = $(this).data('value');
  const index = cutIndex[cutValue];

  // Sadece tıklanan cut değerini alın
  chosenCuts = [cutValue];

  // Slider değerlerini güncelle
  $('#dx-rapgab-cut-range-min').val(index);
  $('#dx-rapgab-cut-range-max').val(index + 1);

  // Cut seçimini güncelle
  updateCutSelection();
});

$('#dx-rapgab-cut-range-min, #dx-rapgab-cut-range-max').on('input', updateCutSelection);

const symmetryOrder = ['Excellent', 'Very%20Good', 'Good'];
const symmetryIndex = {
  'Excellent': 0,
  'Very%20Good': 1,
  'Good': 2
};

// Symmetry etiketlerine tıkladığında çalışacak fonksiyon
// Bu fonksiyon, hem slider hem de etiket tıklamalarında çağrılmalıdır.
function updateSymmetrySelection() {
  let minIndex = parseInt($('#dx-rapgab-symmetry-range-min').val());
  let maxIndex = parseInt($('#dx-rapgab-symmetry-range-max').val());

  // Minimum değerin maksimum 2 olmasını sağla
  if (minIndex > 2) {
    minIndex = 2;
    $('#dx-rapgab-symmetry-range-min').val(minIndex);
  }

  // Eğer minimum değer maksimum değerden büyükse, maksimum değeri minimum değerle eşitle
  if (minIndex >= maxIndex) {
    maxIndex = minIndex + 1;
    $('#dx-rapgab-symmetry-range-max').val(maxIndex);
  }

  chosenSymmetry = [];
  for (let i = minIndex; i < maxIndex; i++) {
    chosenSymmetry.push(symmetryOrder[i]);
  }

  // Symmetry highlight güncellenir.
  const width = ((maxIndex - minIndex) / 3) * 100; 
  const left = (minIndex / 3) * 100;
  $('.dx-rapgab-highlight-track-symmetry').css({
    'left': left + '%',
    'width': width + '%'
  });

  // Verileri yeniden çeker.
  fetchDiamonds(1);
}

$('.dx-symmetry-range-labels span').on('click', function() {
  const symmetryValue = $(this).data('value');
  const index = symmetryIndex[symmetryValue];

  // Sadece tıklanan symmetry değerini alın
  chosenSymmetry = [symmetryValue];

  // Slider değerlerini güncelle
  $('#dx-rapgab-symmetry-range-min').val(index);
  $('#dx-rapgab-symmetry-range-max').val(index + 1);

  // Symmetry seçimini güncelle
  updateSymmetrySelection();
});

$('#dx-rapgab-symmetry-range-min, #dx-rapgab-symmetry-range-max').on('input', updateSymmetrySelection);


const polishOrder = ['Excellent', 'Very%20Good', 'Good'];
const polishIndex = {
  'Excellent': 0,
  'Very%20Good': 1,
  'Good': 2
};

// Polish etiketlerine tıkladığında çalışacak fonksiyon
function updatePolishSelection() {
  let minIndex = parseInt($('#dx-rapgab-polish-range-min').val());
  let maxIndex = parseInt($('#dx-rapgab-polish-range-max').val());

  // Minimum değerin maksimum 2 olmasını sağla
  if (minIndex > 2) {
    minIndex = 2;
    $('#dx-rapgab-polish-range-min').val(minIndex);
  }

  // Eğer minimum değer maksimum değerden büyükse, maksimum değeri minimum değerle eşitle
  if (minIndex >= maxIndex) {
    maxIndex = minIndex + 1;
    $('#dx-rapgab-polish-range-max').val(maxIndex);
  }

  chosenPolish = [];
  for (let i = minIndex; i < maxIndex; i++) {
    chosenPolish.push(polishOrder[i]);
  }

  // Polish highlight güncellenir
  const width = ((maxIndex - minIndex) / 3) * 100; 
  const left = (minIndex / 3) * 100;
  $('.dx-rapgab-highlight-track-polish').css({
    'left': left + '%',
    'width': width + '%'
  });

  // Verileri yeniden çeker
  fetchDiamonds(1);
}

$('.dx-polish-range-labels span').on('click', function() {
  const polishValue = $(this).data('value');
  const index = polishIndex[polishValue];

  // Sadece tıklanan polish değerini alır
  chosenPolish = [polishValue];

  // Slider değerlerini günceller
  $('#dx-rapgab-polish-range-min').val(index);
  $('#dx-rapgab-polish-range-max').val(index + 1);

  // Polish seçimini günceller
  updatePolishSelection();
});

$('#dx-rapgab-polish-range-min, #dx-rapgab-polish-range-max').on('input', updatePolishSelection);


const fluorescenceOrder = ['None', 'Faint', 'Medium', 'Strong', 'Very%20Strong'];
const fluorescenceIndex = {
  'None': 0,
  'Faint': 1,
  'Medium': 2,
  'Strong': 3,
  'Very%20Strong': 4
};

// fluorescence etiketlerine tıkladığında çalışacak fonksiyon
function updateFluorescenceSelection() {
  let minIndex = parseInt($('#dx-rapgab-fluorescence-range-min').val());
  let maxIndex = parseInt($('#dx-rapgab-fluorescence-range-max').val());

  // Minimum değerin maksimum 3 olmasını sağla
  if (minIndex > 4) {
    minIndex = 4;
    $('#dx-rapgab-fluorescence-range-min').val(minIndex);
  }

  // Eğer minimum değer maksimum değerden büyükse, maksimum değeri minimum değerle eşitle
  if (minIndex >= maxIndex) {
    maxIndex = minIndex + 1;
    $('#dx-rapgab-fluorescence-range-max').val(maxIndex);
  }

  chosenFluorescence = [];
  for (let i = minIndex; i < maxIndex; i++) {
    chosenFluorescence.push(fluorescenceOrder[i]);
  }

  // Fluorescence highlight güncellenir
  const width = ((maxIndex - minIndex) / 5) * 100; 
  const left = (minIndex / 5) * 100;
  $('.dx-rapgab-highlight-track-fluorescence').css({
    'left': left + '%',
    'width': width + '%'
  });

  // Verileri yeniden çeker
  fetchDiamonds(1);
}

$('.dx-fluorescence-range-labels span').on('click', function() {
  const fluorescenceValue = $(this).data('value');
  const index = fluorescenceIndex[fluorescenceValue];

  // Sadece tıklanan fluorescence değerini alır
  chosenFluorescence = [fluorescenceValue];

  // Slider değerlerini günceller
  $('#dx-rapgab-fluorescence-range-min').val(index);
  $('#dx-rapgab-fluorescence-range-max').val(index + 1);

  // Fluorescence seçimini günceller
  updateFluorescenceSelection();
});

$('#dx-rapgab-fluorescence-range-min, #dx-rapgab-fluorescence-range-max').on('input', updateFluorescenceSelection);

// Tıklama olayını tanımla
document.querySelector('.dx-rapgab-filter-advanced').addEventListener('click', function() {
    var advancedFilter = document.querySelector('.dx-ragrab-advanced-filter');
    if (advancedFilter) {
        advancedFilter.classList.toggle('active');
    }
});

$('#dxRapgabSearchInput').on('input', function() {
    certNum = $(this).val();

    // Sayısal bir değer olup olmadığını kontrol et, değilse null yap
    if (!certNum || isNaN(certNum)) {
         certNum = null;
    }

    // fetchDiamonds fonksiyonunu çağır
    fetchDiamonds(1);

    
});

// Tüm Popup'ları Kapat
function closeAllPopups() {
    document.querySelectorAll('.dx-rapgab-popup').forEach(popup => {
        popup.style.display = 'none';
    });
}

// Popup'ları Göster
document.querySelectorAll('.dx-rapgab-info-icon').forEach(icon => {
    icon.addEventListener('click', function() {
        closeAllPopups(); // Tüm açık popupları kapat
        const popupId = this.getAttribute('data-popup');
        document.getElementById(popupId).style.display = 'flex';
    });
});

// Popup'ları Kapat
document.querySelectorAll('.dx-rapgab-close-btn').forEach(btn => {
    btn.addEventListener('click', function() {
        this.closest('.dx-rapgab-popup').style.display = 'none';
    });
});

// Popup dışında tıklama ile kapatma
document.addEventListener('click', function(event) {
    const isClickInsidePopup = event.target.closest('.dx-rapgab-popup') || event.target.closest('.dx-rapgab-info-icon');
    if (!isClickInsidePopup) {
        closeAllPopups();
    }
});

  
document.querySelector('.dx-rapgab-fdpv-close').addEventListener('click', function(event) {
    event.preventDefault();
    var detailedProductView = document.querySelector('.dx-rapgab-filter-detailed-product-view');
    if (detailedProductView) {
        detailedProductView.style.display = 'none';
    }
    document.querySelector('.scrollable-table').style.display = 'block';

    // Önceki kaydırma pozisyonuna geri dön
    window.scrollTo({ top: previousScrollPosition, behavior: 'smooth' });
    document.querySelector('.dx-diamond-popup-content-container').scrollTo({ top: previousScrollPopupPosition, behavior: 'smooth' });
});

 fetchDiamonds(currentPage);

// Kullanıcı arayüzündeki sütun adları ve veritabanındaki karşılıkları arasındaki eşleşmeler
const columnMapping = {
    "pırlanta şekli": "shapeOrder",
    "fiyat": "total_sales_price",
    "karat": "size",
    "renk": "colorOrder",
    "berraklık": "clarityOrder",
    "kesim": "cutOrder",
    "parlaklık": "polishOrder",
    "simetri": "symmetryOrder",
    "floresan": "fluor_intensityOrder",
    "sertifika": "lab",
    "sertifika no": "cert_num"
};


    $('#diamondsTable th').on('click', function() {
        const columnText = $(this).text().toLowerCase(); // Sütunun görsel adını al (örneğin 'fiyat')
        const columnField = columnMapping[columnText]; // Eşleme nesnesini kullanarak veritabanı alan adını al
        
        
        if (sortColumn === columnField) {
            sortOrder = sortOrder === '-1' ? '1' : '-1';
        } else {
            sortColumn = columnField;
            sortOrder = '1';
        }
        updateSortIcons($(this));
        fetchDiamonds(1);
    });
  
})